var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBunker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.507812,
    width: 110,
    height: 110,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    transform: "translate(19 33)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.091 39.0669V45.1337H65.2324C66.4731 45.1337 67.7013 45.4244 68.8167 45.9932L75.1456 49.1783L96.0749 44.6535C98.3433 44.1605 99.9224 46.878 98.3934 48.6348L75.5341 74.7477C73.9049 76.4919 71.8245 77.4904 69.5185 77.4904H37.0468C33.7257 77.4904 31.0312 74.7729 31.0312 71.4235V68.7314L22.573 64.9396C20.3999 63.8526 19 61.7924 19 59.3909V51.2006C19 47.8512 21.6932 45.1337 25.0156 45.1337H48.0754V39.0669H42.0598C40.393 39.0669 39.052 37.7145 39.052 36.0334C39.052 34.3587 40.393 33 42.0598 33H60.1066C61.7735 33 63.1144 34.3587 63.1144 36.0334C63.1144 37.7145 61.7735 39.0669 60.1066 39.0669H54.091ZM65.9468 51.782C65.7212 51.6683 65.4831 51.6051 65.2324 51.6051H37.4479V71.0191H69.5185C69.9822 71.0191 70.4209 70.8168 70.7217 70.4756L85.5226 53.5515L74.2934 55.9783L65.9468 51.782ZM31.0312 62.0831V51.2006H25.0156V59.3909L31.0312 62.0831Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunker);
export default __webpack_public_path__ + "static/media/bunker.05bf241fd37faa2fd3fae17d1c60845c.svg";
export { ForwardRef as ReactComponent };